import { gql } from '@apollo/client';

export const FILE_UPLOAD_STATUS = gql`
  query FileUploadStatus(
    $fileIngestionId: Int!
    $page: Int = 1
    $limit: Int = 25
    $orderBy: FileUploadStatusOrderBy = START_TIME
    $sort: SortOrder = ASC
  ) {
    fileUploadStatus(
      fileIngestionId: $fileIngestionId
      page: $page
      limit: $limit
      orderBy: $orderBy
      sort: $sort
    ) {
      totalCount
      pageInfo {
        page
        limit
        hasNextPage
        hasPrevPage
      }
      nodes {
        fileIngestionId
        filename
        parentJobName
        subTaskName
        startTime
        endTime
        duration
        status
        level
        runId
      }
    }
  }
`;
